<template>
  <div id="capture" class="ui stackable grid disable-zoom">
    <div class="sixteen wide column">
      <div class="item-meta">
          <div class="item-name">
              {{itemName}} ({{photoCount}})
          </div>
      </div>
      <web-cam ref="webcam"
            :device-id="deviceId"
            width="100%"
            height="auto"
            @error="onError"
            @cameras="onCameras"
            @started="onStarted"
            @camera-change="onCameraChange" />
      <div id="take-photo">
        <button class="circular ui icon button left floated" @click="openModal">
          <i title="new item" class="plus circle icon big"></i>
        </button>
        <button class="circular ui icon button right floated pp" @click="onCapture">
          <i title="take a photo" class="camera icon big"></i>
        </button>
        <button class="circular ui icon button right floated" @click="changeCamera">
          <i title="change camera" class="icon refresh big"></i>
        </button>
      </div>
    </div>
<!--     <div class="sixteen wide column">
            <select v-model="camera">
                <option
                    v-for="device in devices"
                    :key="device.deviceId"
                    :value="device.deviceId"
                >{{ device.label }}</option>
            </select>
        </div>
        <div class="col-md-12">
        <button type="button" class="btn btn-primary" @click="onCapture">Capture Photo</button>
        <button type="button" class="btn btn-danger" @click="onStop">Stop Camera</button>
        <button type="button" class="btn btn-success" @click="onStart">Start Camera</button>
    </div> -->

    <!-- <div>Gallery: {{currentGallery.name}}</div> -->
    <!-- <div>Device Index: {{deviceIndex}}</div> -->
<!--     <div>Images Count: {{photos.length}}</div> -->
    <!-- <div>Item Photos Count: {{item.photos}}</div> -->
    <div id="loader" class="ui active dimmer" v-if="loading">
      <div class="ui text loader">Loading</div>
    </div>

    <div class="ui mini modal">
        <i class="close icon"></i>
        <div class="header">
            Create a new item
        </div>
        <div class="content">
          <div class="ui form">
            <div class="field twelve wide">
              <label>Item Name</label>
              <div class="ui fluid input">
                <input type="text" placeholder="e.g. camera, tv, shirt" v-model="newItemName">
              </div>
            </div>
            <div class="field twelve wide">
              <label>Item Value</label>
              <div class="ui fluid input">
                <input type="text" placeholder="e.g. $ or priceless" v-model="newItemValue">
              </div>
            </div>
            <div class="field">
              <label></label><br />
              <div class="ui fluid input">
                <div class="ui primary button" @click="newItem">
                  Create
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], {type:mimeString});
}

import { WebCam } from "vue-web-cam";
import { mapGetters } from 'vuex'
import firebase from 'firebase'
export default {
  name: 'Capture',
  props: {},
  components: {
    WebCam
  },
    data() {
        return {
            imgs: [],
            camera: null,
            deviceId: null,
            deviceIndex: 0,
            devices: [],
            multipleDevices: false,
            currentGallery: {name: 'defaulter'},
            item: {name: '<not-set>', id:-1, photos: []},
            loading: true,
            newItemName: "",
            newItemValue: "",
            pendingData: ""
        };
    },
    computed: {
        device: function() {
            return this.devices.find(n => n.deviceId === this.deviceId);
        },
        itemName: function() {
            return this.item.name
        },
        photoCount: function() {
            if (this.item && this.item.photos) {
                return this.item.photos.length
            }
            return 0
        },
        mainAccount: function() {
          if (this.accounts.length == 0) {
            return {id: this.user.uid, default_account: this.user.uid, users: []}
          }
          return this.accounts.filter(account => account.id == this.user.uid)[0]
        },
        ...mapGetters({
        user: 'getUser',
        accounts: 'AccountModule/get',
        // galleries: 'GalleryModule/get',
        // photos: 'PhotoModule/get',
        items: 'ItemModule/get',
      })
    },
    async mounted() {
      if (this.galleries && this.galleries.length > 0) {
        this.currentGallery = this.galleries[1]
      }

      if (this.$route.params.id) {
        this.item = await this.$store.getters['ItemModule/getById'](this.$route.params.id)
      }
    },
    beforeDestroy() {
      this.onStop();
    },
    watch: {
        camera: function(id) {
            this.deviceId = id;
        },
        devices: function() {
            const lastDevice = this.devices.length - 1;
            if (lastDevice >= 0) {
                this.camera = this.devices[lastDevice].deviceId;
                this.deviceId = this.devices[lastDevice].deviceId;
            }
        }
    },
    methods: {
        // async addGallery() {
        //   this.$store.dispatch('GalleryModule/create', {name: 'test', id: -1})
        // },
        async onCapture() {
            const data = this.$refs.webcam.capture()
            // this.imgs.push(data)
            this.addPhoto(data)
        },
        async addPhoto (data) {
          if (this.item.id == -1) {
            this.pendingData = data
            this.openModal()
          } else {
            this.loading = true
            const id = await this.$store.dispatch('PhotoModule/create', {itemRef: this.item.id, created_by: this.mainAccount.default_account})

            if (this.user.uid != this.mainAccount.default_account) {
              await this.$store.dispatch('PhotoModule/updateOwner', {id: id, created_by: this.mainAccount.default_account})
            }

            this.item.photos.push(id)
            this.$store.dispatch('ItemModule/addPhoto', {id: this.item.id, photos: this.item.photos})
            this.uploadPhoto(id, data)
            this.loading = false
          }
        },
        async uploadPhoto (id, data) {
            // const storageUrl = 'https://storage.cloud.google.com/our-assets.appspot.com/images/'
            const blob = dataURItoBlob(data)
            const storageRef = await firebase.storage().ref(`${id}.jpg`).put(blob)
            let imageUrl = await storageRef.ref.getDownloadURL()
            // let photoUrl = await firebase.storage().ref(`${id}_640x640.jpeg`).getDownloadURL()
            // let thumbUrl = await firebase.storage().ref(`${id}_290x290.jpeg`).getDownloadURL()

            //gs://our-assets.appspot.com/images/1gF5WCLpYsg0AMj5uC6G_218x290.jpeg

            this.$store.dispatch('PhotoModule/setUrl', {id: id, originalUrl: imageUrl, data: id, itemRef: this.item.id})
            this.$store.dispatch('ItemModule/setUrl', {data: imageUrl, originalUrl: imageUrl, id: this.item.id})
        },
        changeCamera() {
            var deviceIndex = this.deviceIndex + 1
            this.deviceIndex = deviceIndex % this.devices.length

            this.camera = (this.devices[this.deviceIndex].deviceId)
        },
        openModal() {
          this.item = {name: "<not-set>", id: -1, photos: []}
          this.newItemName = ""
          this.newItemValue = ""
          window.jQuery('.ui.modal').modal('show')
        },
        async newItem() {
            window.jQuery('.ui.modal').modal('hide')
            this.loading = true

            this.item = {name: "loading", id: -2, photos: []}
            const id = await this.$store.dispatch('ItemModule/create', {name: this.newItemName, value: this.newItemValue, id: -1, created_by: this.mainAccount.default_account})
            this.item = await this.$store.getters['ItemModule/getById'](id)

            if (this.user.uid != this.mainAccount.default_account) {
              await this.$store.dispatch('ItemModule/updateOwner', {id: this.item.id, created_by: this.mainAccount.default_account})
            }

            if (this.pendingData != "") {
              await this.addPhoto(this.pendingData)
              this.pendingData = ""
            }
            this.loading = false
        },
        setItem(item) {
            this.item = item
        },
        onStarted() {
            this.loading = false
        },
        // onStopped(stream) {
        //     // console.log("On Stopped Event", stream);
        // },
        onStop() {
            this.$refs.webcam.stop();
        },
        onStart() {
            this.$refs.webcam.start();
        },
        onError(error) {
            console.log("On Error Event", error);
        },
        onCameras(cameras) {
            this.devices = cameras;
            // console.log("On Cameras Event", cameras);
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId;
            this.camera = deviceId;
            // console.log("On Camera Change Event", deviceId);
        }
    }
}
</script>

<style scoped>
.disable-zoom {
  touch-action: manipulation;
}
.item-meta {
    font-size: 2em;
    position: absolute;
    color: #fff;
    margin: 15px;
    width: 90%;
    text-shadow: 1px 1px #000;
}

.item-meta .item-name {
    float: left;
}
.item-meta .item-photo-count {
    float: right;
}

#take-photo {text-align: center; margin:0 auto; transform: translateY(-75px);}
#take-photo button:first-of-type {margin-left: 15px;}
#take-photo button {margin-right: 15px;}

</style>
